var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcLocation20X20 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M10 1.5A6.5 6.5 0 0 1 16.5 8c0 3.178-1.812 5.475-4.948 8.658l-.846.849c-.611.6-.753.632-1.314.095l-.633-.63-.602-.61C5.23 13.36 3.5 11.09 3.5 8A6.5 6.5 0 0 1 10 1.5m0 4a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5"
})));
export default SvgIcLocation20X20;